"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Wrench, PenTool } from "lucide-react";
const faqs = [{
  question: "תוך כמה זמן מגיע מטפל סיעודי לבית המטופל?",
  answer: "אנו מתחייבים למציאת פתרון והגעת מטפל סיעודי מקצועי לביתכם תוך 5 שעות בלבד מרגע הפנייה, בכל רחבי הארץ, כדי להבטיח רצף טיפולי ושקט נפשי למשפחה."
}, {
  question: "האם המטפלים שלכם עוברים הכשרה מקצועית?",
  answer: "בהחלט. כל המטפלים בצוות שלנו עוברים סינון קפדני, בדיקת רקע והכשרות מקצועיות בתחומי הסיעוד, העזרה הראשונה והתמיכה הרגשית למטופלים בגיל השלישי."
}, {
  question: "האם ניתן לקבל שירות גם בסופי שבוע וחגים?",
  answer: "כן, המוקד שלנו פעיל 24/7 ואנו מספקים שירותי סיעוד דחופים גם בשבתות, חגים ובשעות הלילה, מתוך הבנה שצורך סיעודי יכול להתעורר בכל רגע."
}, {
  question: "איך מתבצע תהליך ההתאמה בין המטפל למטופל?",
  answer: "אנו מבצעים אבחון טלפוני מהיר של צרכי המטופל, מצבו הרפואי והעדפותיו האישיות, ומתאימים לו את המטפל בעל הניסיון הרלוונטי ביותר למקרה הספציפי."
}, {
  question: "האם אתם מסייעים בהגשת תביעות לביטוח הלאומי?",
  answer: "הצוות המקצועי שלנו מעניק ייעוץ ראשוני והכוונה לגבי מיצוי זכויות מול המוסד לביטוח לאומי וחברות הביטוח הפרטיות, כדי להקל עליכם את התהליך הבירוקרטי."
}, {
  question: "מה קורה אם המטפל אינו מתאים למטופל?",
  answer: "שביעות הרצון שלכם היא בראש סדר העדיפויות שלנו. במידה ואין התאמה, אנו נדאג להחלפת המטפל במהירות האפשרית תוך שמירה על רצף הטיפול."
}, {
  question: "האם השירות כולל גם השגחה בבתי חולים?",
  answer: "כן, אנו מספקים שירותי השגחה וליווי סיעודי גם במהלך אשפוז בבתי חולים, כדי להבטיח שהיקיר שלכם יקבל יחס אישי וטיפול צמוד גם מחוץ לבית."
}];
const relatedServices = [{
  title: "סיעוד דחוף מיידי",
  description: "מענה מהיר במיוחד למצבים קריטיים, שחרור מבית חולים או החמרה פתאומית במצב הרפואי.",
  icon: Wrench
}, {
  title: "ליווי והשגחה 24/7",
  description: "שירותי סיעוד מקיפים מסביב לשעון על ידי מטפלים מוסמכים ומסורים בבית המטופל.",
  icon: PenTool
}];
export default function FaqSection() {
  return <section data-section-id="260540" id="שאלות-נפוצות" className="w-full flex flex-col bg-background text-foreground">
      {}
      <div className="w-full bg-background py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-center mb-12 text-primary">
            שאלות ותשובות על שירותי סיעוד
          </h2>

          <Accordion type="single" collapsible className="w-full space-y-4">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-none bg-muted/50 rounded-lg px-2 shadow-md">
                <AccordionTrigger className="hover:no-underline text-base md:text-lg font-default font-semibold py-5 px-4 text-foreground text-right">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground px-4 pb-5 leading-relaxed text-base font-sans">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>

          {}
          <div className="mt-24 text-center">
            <h3 className="text-2xl md:text-3xl font-default font-bold mb-3 text-primary">
              שירותים משלימים למשפחה
            </h3>
            <p className="text-muted-foreground mb-10 text-lg font-sans">
              פתרונות סיעוד מותאמים אישית לכל צורך רפואי ורגשי
            </p>

            <div className="grid md:grid-cols-2 gap-6 text-right">
              {relatedServices.map((service, i) => <div key={i} data-index={i} className="bg-card border border-border rounded-lg p-6 flex gap-5 items-start shadow-lg">
                  <div className="bg-accent p-3 rounded-lg shrink-0">
                    <service.icon className="w-5 h-5 text-secondary" />
                  </div>
                  <div>
                    <h4 className="font-default font-bold text-lg mb-2 text-foreground">
                      {service.title}
                    </h4>
                    <p className="text-sm text-muted-foreground leading-relaxed font-sans">
                      {service.description}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="w-full bg-muted/30 py-16 md:py-20 border-t border-border">
        <div className="container mx-auto px-4 text-center max-w-3xl">
          <h3 className="text-2xl md:text-3xl font-default font-bold mb-4 text-primary">
            שירותי סיעוד בפריסה ארצית
          </h3>
          <p className="text-muted-foreground text-lg font-sans">
            אנו מספקים מענה מהיר בערים המרכזיות ובכל רחבי הארץ עם צוות מטפלים זמין ומקצועי
          </p>
        </div>
      </div>
    </section>;
}